<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Mail Gönderme Kuyruğu</h4>
              <p class="card-category">Gönderilmesi Planlanan ve gönderilen mailler aşağıdadır.</p>
            </template>





            <div class="row p-3">
              <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-fill ml-2" @click="selectStatusFilter(type[0])"
                  :class="statusFilter.includes(type[0]) ? 'btn-success' : ''"
                  v-for="type of Object.entries(types.status)">{{ type[1] }}</button>

              </div>
            </div>
            <div class="row">
              <div class="col-3 ml-2">
                <input class="form-control form-control-lg" @change="getMailSend()" v-model="queryText" type="text"
                  placeholder="Arama">
              </div>

            </div>

            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ fromMails[item.fromMailId].mail }}</td>
                    <td>{{ item.toUserEmail }}</td>
                    <td>{{ types.status[item.status] }}</td>
                    <td>{{ types.type[item.type] }}</td>
                    <td>{{ templates[item.mailTemplateId].title }}</td>
                    <td>{{ item.sendedDate ? new Date(item.sendedDate).toLocaleString('de') : '-' }}</td>
                    <td>{{ item.openedDate ? new Date(item.openedDate).toLocaleString('de') : '-' }}</td>
                    <td @click="deleteItem(item._id)"><button><i class="nc-icon nc-simple-remove"></i></button></td>

                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../services/collection.service.js";

const tableColumns = ['Kimden', 'Kime', 'Durum', 'Tür', "İçerik", "Gönderilme Tarihi", 'Açıldı mı?']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      fromMails: {},
      templates: {},
      statusFilter: ['pending', 'sended', 'opened'],
      queryText: '',
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      types: {
        "status": {
          "pending": "Kuyrukta",
          "sending": "Gönderiliyor",
          "opened": "Açıldı",
          "error": "Hata oluştu",
          "sended": "Gönderildi"
        },
        "type": { "marketing": "Pazarlama" }
      }
    }
  },
  mounted() {
    this.getFromMails();
    this.getTemplates();
    this.getMailSend();
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getMailSend();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getMailSend() {
      let q = { status: { '$in': this.statusFilter }, toUserEmail: { '$regex': this.queryText, $options: 'i' } };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mailsend', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.mailSends;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    getFromMails() {
      let q = {};
      let p = {};
      let o = {}
      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('frommail', query).then((res) => {
        if (res.success == true) {
          this.fromMails = res.fromMails.reduce((p, n) => ({ ...p, [n._id]: n }), {});
        } else {
          console.log('error');
        }
      })
    },
    getTemplates() {
      let q = {};
      let p = {};
      let o = {}
      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mailtemplate?noCounts=1').then((res) => {
        if (res.success == true) {
          this.templates = res.mailTemplates.reduce((p, n) => ({ ...p, [n._id]: n }), {});
        } else {
          console.log('error');
        }
      })
    },
    deleteItem(_id) {
      CollectionService.deleteItem('mailsend', _id).then((res) => {
        this.getMailSend();
      })
    },
    selectStatusFilter(_id) {
      if (!this.statusFilter.includes(_id)) {
        this.statusFilter.push(_id);
      } else {
        this.statusFilter = this.statusFilter.filter(x => x != _id)
      }
      this.getMailSend()
    },
  }
}
</script>
<style></style>